(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-hoops-carousel"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(scope){scope.querySelectorAll('[data-ribbon]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const view=root.querySelector('[data-ribbon-viewport]'),rail=root.querySelector('[data-ribbon-rail]'),original=root.querySelector('[data-ribbon-original]'),button=root.querySelector('[data-ribbon-pause]');
const reduced=matchMedia('(prefers-reduced-motion:reduce)');
if(reduced.matches)return;
let width=0,x=0,last=0,paused=false,hover=false,focus=false,touch=false,lastX=0,startX=0,moved=false,blockClick=0,visible=true,items=[];
function draw(){
rail.style.transform='translate3d('+x+'px,0,0)';
const center=view.getBoundingClientRect().left+view.clientWidth/2;
items.forEach(item=>{
const rect=item.getBoundingClientRect(),distance=Math.min(1,Math.abs(rect.left+rect.width/2-center)/(rect.width+20));
const mobileBoost=view.clientWidth<=749?.10*Math.pow(1-distance,2):0;
const scale=1-.24*distance+mobileBoost,y=18*distance;
item.querySelector('.rr__scene').style.transform='translateY('+y+'px) scale('+scale+')';
});
}
function normalize(){if(width){while(x<=-2*width)x+=width;while(x>-width)x-=width;}}
function build(){
rail.querySelectorAll('[data-ribbon-clone]').forEach(n=>n.remove());width=original.getBoundingClientRect().width;
if(!width)return;
for(let i=0;i<3;i++){const clone=original.cloneNode(true);clone.removeAttribute('data-ribbon-original');clone.setAttribute('data-ribbon-clone','');clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a').forEach(a=>a.tabIndex=-1);clone.querySelectorAll('[data-shopify-editor-block]').forEach(n=>n.removeAttribute('data-shopify-editor-block'));rail.appendChild(clone);}
items=[...rail.querySelectorAll('.rr__item')];
x=-width+view.clientWidth/2-original.firstElementChild.offsetWidth/2;normalize();draw();
}
button.addEventListener('click',()=>{paused=!paused;root.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?'Play animation':'Pause animation');button.textContent=paused?'▷':'Ⅱ';});
view.addEventListener('mouseenter',()=>hover=true);view.addEventListener('mouseleave',()=>hover=false);
view.addEventListener('focusin',event=>{focus=true;const item=event.target.closest('.rr__item');if(item){const offset=item.getBoundingClientRect().left-view.getBoundingClientRect().left;x+=view.clientWidth/2-offset-item.offsetWidth/2;draw();}});
view.addEventListener('focusout',()=>requestAnimationFrame(()=>{focus=view.contains(document.activeElement);}));
view.addEventListener('touchstart',e=>{if(e.touches.length===1){touch=true;startX=lastX=e.touches[0].clientX;moved=false;}},{passive:true});
view.addEventListener('touchmove',e=>{if(!touch||e.touches.length!==1)return;const next=e.touches[0].clientX;if(Math.abs(next-startX)>8)moved=true;if(moved){e.preventDefault();x+=next-lastX;normalize();draw();}lastX=next;},{passive:false});
function finish(){touch=false;if(moved)blockClick=performance.now()+350;}
view.addEventListener('touchend',finish,{passive:true});view.addEventListener('touchcancel',finish,{passive:true});
view.addEventListener('click',e=>{if(performance.now()<blockClick){e.preventDefault();e.stopPropagation();}},true);
const resize=new ResizeObserver(build);resize.observe(view);
const visibility=new IntersectionObserver(entries=>visible=entries[0].isIntersecting);visibility.observe(root);
build();
function frame(now){if(!root.isConnected){resize.disconnect();visibility.disconnect();return;}const dt=last?Math.min((now-last)/1000,.05):0;last=now;if(visible&&!document.hidden&&!paused&&!hover&&!focus&&!touch&&!reduced.matches){x-=28*dt;normalize();draw();}requestAnimationFrame(frame);}
requestAnimationFrame(frame);
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksc-etsy-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ksc-etsy-reviews')){
customElements.define('ksc-etsy-reviews',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.track=this.querySelector('.ksc-track');if(!this.track)return;
  this.cards=[...this.track.children];this.prev=this.querySelector('.ksc-prev');this.next=this.querySelector('.ksc-next');
  this.reviewControls=[...this.querySelectorAll('.ksc-review-copy')].map(copy=>({quote:copy.querySelector('.ksc-quote'),button:copy.querySelector('.ksc-review-toggle')}));
  const fullHeights=this.reviewControls.map(({quote})=>quote.scrollHeight);
  this.classList.add('is-enhanced');
  requestAnimationFrame(()=>this.reviewControls.forEach(({quote,button},index)=>{button.hidden=fullHeights[index]<=quote.clientHeight+1}));
  this.reviewControls.forEach(({quote,button})=>button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';quote.classList.toggle('is-expanded',!expanded);button.setAttribute('aria-expanded',String(!expanded));button.textContent=expanded?button.dataset.readMoreLabel:button.dataset.showLessLabel;requestAnimationFrame(()=>this.update())},opts));
  this.prev.addEventListener('click',()=>this.move(-1),opts);this.next.addEventListener('click',()=>this.move(1),opts);
  this.track.addEventListener('scroll',()=>this.update(),{...opts,passive:true});
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();if(e.key==='Home'||e.key==='End')this.track.scrollTo({left:e.key==='Home'?0:this.track.scrollWidth,behavior:this.behavior()});else this.move(e.key==='ArrowLeft'?-1:1)}},opts);
  this.querySelectorAll('img').forEach(img=>img.addEventListener('error',()=>{if(img.closest('.ksc-avatar'))img.remove();else img.closest('.ksc-photo-button')?.setAttribute('hidden','')},opts));
  this.dialog=this.querySelector('dialog');
  this.querySelectorAll('.ksc-photo-button').forEach(b=>b.addEventListener('click',()=>{const img=b.querySelector('img');const large=this.dialog.querySelector('img');large.src=img.src;large.alt=img.alt;this.dialog.showModal()},opts));
  this.querySelector('.ksc-close').addEventListener('click',()=>this.dialog.close(),opts);
  this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}},opts);
  this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.ksc-card');if(card)this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'})},opts);
  this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect()}
 behavior(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}
 move(dir){const gap=parseFloat(getComputedStyle(this.track).gap)||0;const step=this.cards[0]?.getBoundingClientRect().width+gap;if(step)this.track.scrollBy({left:dir*step,behavior:this.behavior()})}
 update(){const max=this.track.scrollWidth-this.track.clientWidth;this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=max-2;this.prev.hidden=this.next.hidden=max<=2}
});}


  } catch(e) { console.error(e); }
})();
})();
